export default __webpack_public_path__ + "518d486cef8e595559b131a11c8faf97.svg";